import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "./../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import SexNextStepButton from "./sexNextStepButton"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "./../../../shared/services/service.step"
import { sexData } from "./static.sexData"
import { steps } from "./../../../shared/static.steps"
import locales from "./../../../content.json";

import female from './img/female.png';
import male from './img/male.png';

import styles from './sex.module.scss'
import "./../../../shared/services/service.step.scss"

class Sex extends Component {
  constructor() {
    super();

    this.state = {
      isOpenSex: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.sex) && !this.state.isOpenSex)
      this.setState({ isOpenSex: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, onSetStepData, data } = this.props
    const { isOpenSex } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.sex,
      isOpen: isOpenSex,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenSex && !has(data, ["sex"]))
      onSetStepData("sex")

    if (isOpenSex && has(data, ["sex"])) {
      // this.props.onToNextStep();
    }

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenSex: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData, firstQuestionA } = this.props
    const { isOpenSex } = this.state
    const params = {
      className: "wrapperSex",
      currentIndex: currentIndex,
      stepIndex: steps.sex,
    }

    return isOpenSex ?
      <div className={buildStepClassName({ params })}>
        <StepContentWrapper className='fsdafsad'>
        <FirstTitle>{locales[window.userLang].select_gender}</FirstTitle>
          <div className={styles.gender}>
            <button
              className={styles.genderButton}
              onClick={() => {
                onUpdateStepData.bind(this, "sex", "value", "female")();
                this.props.onToNextStep();
              }}
            >
              <img src={female} alt="female"/>
              {locales[window.userLang].female}
            </button>
            <button
              className={styles.genderButton}
              onClick={() => {
                onUpdateStepData.bind(this, "sex", "value", "male")();
                this.props.onToNextStep();
              }}
            >
              <img src={male} alt="male"/>
              {locales[window.userLang].male}
            </button>
          </div>
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(Sex);